
























































































































































































import {Component, Vue} from "vue-property-decorator";
import {
 Checkbox,
 CheckboxGroup,
 Radio,
 RadioGroup,
 Button,
 Field
} from "vant";

@Component({
 name: 'CustomerState',
 components: {
  [Checkbox.name]: Checkbox,
  [CheckboxGroup.name]: CheckboxGroup,
  [Radio.name]: Radio,
  [RadioGroup.name]: RadioGroup,
  [Button.name]: Button,
  [Field.name]: Field
 }
})
export default class CustomerState extends Vue {
 statementOptions: any = [];
 result = [
  {
   value: 3
  },
  {
   value: 3,
   input_value: "",
   input_value_2: ""
  },
  {
   value: 3,
   // input_value: "",
   input_value_2: ""
  },
  {
   value: 3
  },
  {
   value: 3,
   input_value: ""
  }
 ];

 selectResult: Boolean = true
  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

 created() {
  
  this.statementOptions = this.$t(
   "open_account.customer_state.statement_list"
  );
 }

 handleChangeRadio(item) {
  item.input_value && (item.input_value = "");
  item.input_value_2 && (item.input_value_2 = "");

  this.selectResult = !!this.result.find(item => item.value === 3)
 }

 handleChangeFirst(e) {
  this.selectResult = !!this.result.find(item => item.value === 3)
  // (this as any).selectResult = false
 }

 handleSaveCustomerState() {
  // const isAllChecked = this.statementOptions.every(item => {
  //   return item.value == true;
  // });
  // if (!isAllChecked) {
  //   return this.$toast.fail(
  //     this.$t("open_account.customer_state.fail_toast_text")
  //   );
  // }
  const map = [0, 1, 1, 1, 1];
  const num = this.result.findIndex((item, index) => {
   const arg = Object.keys(item).filter(key => key !== "value");
   if (item.value == map[index]) {
    if (arg.length == 0) {
     return true;
    } else {
     return arg.some(key => {
      return item[key] === "";
     });
    }
   } else {
    return false;
   }
  });
  if (num > -1) {
   const el = document.querySelectorAll(".state-item")[num];
   
   el && el.scrollIntoView(true);
   return;
  }

  (this as any).$apis
   .saveCustomerState({
    customer_state: this.result
   })
   .then(res => {
    
    this.$router.push("/tax-resident-info");
    // this.$router.push({
    //   path: "/survey",
    //   query: this.$route.query
    // });
   })
   .catch(e => {
    
   });
 }
}
